import Home from "../pages/home";
import ServicesPage from "../pages/services";
import TeamPage from "../pages/team";
import FeaturesPage from "../pages/features";
import TermsConditionPage from "../pages/termsCondition";
import FAQPage from "../pages/faq";
import Blogs from "../pages/blogs";
import BlogDetails from "../pages/blogDetails";
import ContactPage from "../pages/contact";
import AboutPage from "../pages/about";

const routes = [
    { path: "/", component: Home },
    { path: "/services", component: ServicesPage },
    { path: "/team", component: TeamPage },
    { path: "/features", component: FeaturesPage },
    { path: "/terms-condition", component: TermsConditionPage },
    { path: "/faq", component: FAQPage },
    { path: "/blogs", component: Blogs },
    { path: "/post", component: BlogDetails },
    { path: "/contact", component: ContactPage },
    { path: "/about", component: AboutPage }
];

export default routes;
